import React from 'react';

export function MainMenuPlaceholder() {
  return (
    <React.Fragment>
      <div
        className="main-menu-placeholder"
        style={{
        paddingTop: '8px',
        backgroundColor: '#f3f2f1',
        height: '100%',
        width: '100%',
      }}
      >
        <div style={{
          display: 'flex',
        }}
        >
          <div style={{
            margin: '0px 8px 8px 8px',
            backgroundColor: '#e1dfdd',
            height: '28px',
            width: '31px',
          }}
          />
          <div style={{
            width: '1px',
            right: '0',
            height: '44px',
            marginTop: '-8px',
            position: 'absolute',
            backgroundColor: '#e1dfdd',
          }}
          />
        </div>
        <div style={{
          top: '44px',
          width: '100%',
          bottom: '0',
          display: 'flex',
          position: 'absolute',
          borderTop: 'solid 1px #e1dfdd',
          borderRight: 'solid 1px #e1dfdd',
          flexDirection: 'column',
        }}
        >
          <div style={{
            margin: '8px 8px 8px 8px',
            backgroundColor: '#e1dfdd',
            minHeight: '20px',
            width: 'calc(100%-16)',
          }}
          />
          <div style={{
            margin: '0px 8px 8px 8px',
            backgroundColor: '#e1dfdd',
            minHeight: '20px',
            width: 'calc(100%-16)',
          }}
          />
          <div style={{
            borderTop: 'solid 1px #e1dfdd',
          }}
          />
          <div style={{
            margin: '8px 8px 0px 8px',
            backgroundColor: '#e1dfdd',
            minHeight: '20px',
            width: 'calc(100%-16)',
          }}
          />
          <div style={{
            margin: '8px 8px 16px 8px',
            backgroundColor: '#e1dfdd',
            Height: 'calc(100%-16)',
            width: 'calc(100%-16)',
            flexGrow: 1,
          }}
          />
        </div>
      </div>
    </React.Fragment>
  );
}

